import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaSpringApi = createApi({
    reducerPath: "core/measurement/spring",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementSpringList"],
    endpoints: (builder) =>({
        measurementSpringFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementSpringList'],
            query: (query = '') => ({
                url: "core/measurement/spring" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementSpringCreate: builder.mutation({
            invalidatesTags: ['measurementSpringList'],
            query: (data)=>({url: "core/measurement/spring", method: "POST", data})
        }),
        measurementSpringUpdate: builder.mutation({
            invalidatesTags: ['measurementSpringList'],
            query: (data)=>({url: "/core/measurement/spring/"+data.id, method: "PUT", data})
        }),
        measurementSpringDelete: builder.mutation({
            invalidatesTags: ['measurementSpringList'],
            query: (id)=>({url: "/core/measurement/spring/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementSpringFindAllQuery, useMeasurementSpringCreateMutation, useMeasurementSpringUpdateMutation, useMeasurementSpringDeleteMutation } = meaSpringApi;
export {meaSpringApi};
